import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Modal, ModalProps } from '@xsolla/ui-modal';

import {
  ContentWrapper,
  ExampleWidgetTitle,
  ExampleWrapper,
  ImageWrapper
} from './styleExampleWidgetModal';

type Props = ModalProps & {
  firstImgExampleSrc: ReactNode;
  secondImgExampleSrc?: ReactNode;
};

const ExampleWidgetModal = ({
  firstImgExampleSrc,
  secondImgExampleSrc,
  ...props
}: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <Modal {...props}>
      <ContentWrapper>
        <ExampleWrapper data-test-id="widget-preview">
          <ImageWrapper>{firstImgExampleSrc}</ImageWrapper>
          {secondImgExampleSrc && <ImageWrapper>{secondImgExampleSrc}</ImageWrapper>}
        </ExampleWrapper>
        <ExampleWidgetTitle data-test-id="widget-preview-text">
          {intl.messages['navigation.authentication-method.example-project.modal']}
        </ExampleWidgetTitle>
      </ContentWrapper>
    </Modal>
  );
};

export default ExampleWidgetModal;
